module.exports = __webpack_public_path__ + "img/tryenglish-02.9705fea.png";